import {useState, useEffect} from 'react';

function useNow() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timeout = 60 - now.getSeconds();
    const timeoutId = setTimeout(() => {
      setNow(new Date());
    }, timeout * 1000);

    return () => clearTimeout(timeoutId);
  }, [now]);

  return now;
}

export default useNow;
